export const WIN_MESSAGES = ['Čestitamo!']
